import React from "react";
import {
  Box,
  VStack,
  Text,
  Button,
  Badge,
  Flex,
  Tooltip,
  Spacer
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../utils/timeUtils";

interface ClientDetailsProps {
  type: string;
  projectsShown: string;
  projectsList: string;
  pendingAction: string;
  lastMeeting: string;
  totalMeetings: string;
  isPendingActionHighlighted: boolean;
  clientId?: string;
  name?: string;
  email?: string;
  lastMeetingDate:any;
  meetingCount: number;
  nextMeetingDate?: any; // Optional, if you want to show next meeting date
}

export function ClientDetails({
  type,
  projectsShown,
  projectsList,
  pendingAction,
  lastMeeting,
  totalMeetings,
  isPendingActionHighlighted,
  clientId = "1",
  name = "",
  email = "",
  lastMeetingDate,
  meetingCount,
  nextMeetingDate
}: ClientDetailsProps) {
  const isChannelPartner = type === "Channel Partner";
  const navigate = useNavigate();

  const firstProject = projectsList.split(",")[0].trim();
  
  const handleViewProfile = () => {
    navigate(`/client-profile/${clientId}?name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}`);
  };

  return (
    <Box
      as="section"
      display="flex"
      flexDirection="column"
      flex="1"
      p={6}
      bg="white"
      position="relative"
      minWidth="0"
      height="100%"
    >
      <Badge
        position="absolute"
        top={4}
        right={6}
        px={4}
        py={1.5}
        fontSize="xs"
        fontWeight="500"
        bg={isChannelPartner ? "#805AD5" : "#38A169"}
        color="white"
        borderRadius="md"
        textTransform="none"
      >
        {type}
      </Badge>
      
      <Box
        display="flex"
        flexDirection="column"
        flex="1"
        justifyContent="space-between"
        mt={16}
        width="100%"
      >
        <VStack spacing={3} align="flex-end" width="100%">
          <Flex justifyContent="flex-end" width="100%" alignItems="center">
            <Text fontSize="sm" color="gray.800" whiteSpace="nowrap" mr={2} flexShrink={0}>
              Projects Shown:
            </Text>
            <Text fontSize="sm" color="gray.500" whiteSpace="nowrap" mr={1} flexShrink={0}>
              ({projectsShown})
            </Text>
            <Tooltip 
              label={projectsList} 
              placement="bottom" 
              hasArrow
              bg="#805AD5" 
              color="white"
              borderRadius="md"
              fontSize="sm"
              fontWeight="medium"
              px={3}
              py={2}
            >
              <Text 
                fontSize="sm" 
                color="gray.500" 
                textAlign="right"
                cursor="pointer"
                _hover={{ color: "#805AD5" }}
                noOfLines={1}
                flexShrink={1}
                textTransform={"capitalize"}
              >
                {firstProject.replace("_"," ")}
              </Text>
            </Tooltip>
          </Flex>
          
          <Flex justifyContent="flex-end" width="100%" alignItems="center">
            <Text fontSize="sm" color="gray.500" whiteSpace="nowrap" mr={2} flexShrink={0}>
              Last Meeting:
            </Text>
            <Text fontSize="sm" fontWeight="500" whiteSpace="nowrap" flexShrink={0}>
              {formatDate(lastMeetingDate)}
            </Text>
          </Flex>
          { nextMeetingDate && <Flex justifyContent="flex-end" width="100%" alignItems="center">
            <Text fontSize="sm" color="gray.500" whiteSpace="nowrap" mr={2} flexShrink={0}>
              Next Meeting:
            </Text>
            <Text fontSize="sm" fontWeight="500" whiteSpace="nowrap" flexShrink={0}>
              {formatDate(nextMeetingDate)}
            </Text>
          </Flex>}
          <Flex justifyContent="flex-end" width="100%" alignItems="center">
            <Text fontSize="sm" color="gray.500" whiteSpace="nowrap" mr={2} flexShrink={0}>
              Total Meetings:
            </Text>
            <Text fontSize="sm" fontWeight="500" whiteSpace="nowrap" flexShrink={0}>
              {meetingCount}
            </Text>
          </Flex>
        </VStack>
        
        <Button
          alignSelf="flex-end"
          mt={4}
          bg="#1A202C"
          color="white"
          _hover={{ bg: "#2D3748" }}
          width="120px"
          height="auto"
          py={2}
          fontSize="xs"
          fontWeight="500"
          borderRadius="md"
          onClick={handleViewProfile}
        >
          View Profile
        </Button>
      </Box>
    </Box>
  );
} 